import { ErrorHelper } from '@/helpers/ErrorHelper'
import { WebApi } from '@/services/WebApi'

const state = () => ({
  timeFormatSettingCaches: []
})

const getters = {
  findTimeFormatSettingCache: (state) => key => state.timeFormatSettingCaches.find(dfsc => dfsc.key === key)
}

const mutations = {
  setLoading (state, { key, loading }) {
    const existing = state.timeFormatSettingCaches.find(dfsc => dfsc.key === key)
    if (existing) {
      existing.loading = !!loading
      existing.retry = false
    } else {
      state.timeFormatSettingCaches.push({ key: key, value: null, loading: !!loading })
    }
  },
  setTimeFormatSetting (state, { key, timeFormatSetting }) {
    const existing = state.timeFormatSettingCaches.find(dfsc => dfsc.key === key)
    if (existing) {
      existing.value = timeFormatSetting
      existing.loading = false
    } else {
      state.timeFormatSettingCaches.push({ key: key, value: timeFormatSetting, loading: false })
    }
  },
  setRetry (state, key) {
    const existing = state.timeFormatSettingCaches.find(dfsc => dfsc.key === key)
    if (existing) {
      existing.retry = true
    }
  }
}

const actions = {
  fetchTimeFormatSetting ({ commit }, siteId) {
    return new Promise((resolve, reject) => {
      commit('setLoading', { key: siteId, loading: true })
      WebApi.get('TimeFormatSetting')
        .then(response => {
          commit('setTimeFormatSetting', { key: siteId, timeFormatSetting: response.data })
          resolve(response)
        })
        .catch(error => {
          if (ErrorHelper.isNotFound(error)) {
            commit('setLoading', { key: siteId, loading: false })
            resolve(false)
          } else {
            commit('setRetry', siteId)
            reject(error)
          }
        })
    })
  },
  fetchTimeFormatSettingBySiteId ({ commit }, siteId) {
    return new Promise((resolve, reject) => {
      commit('setLoading', { key: siteId, loading: true })
      WebApi.get('Portal/' + siteId + '/TimeFormatSetting')
        .then(response => {
          commit('setTimeFormatSetting', { key: siteId, timeFormatSetting: response.data })
          resolve(response)
        })
        .catch(error => {
          if (ErrorHelper.isNotFound(error)) {
            commit('setLoading', { key: siteId, loading: false })
            resolve(false)
          } else {
            commit('setRetry', siteId)
            reject(error)
          }
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
